module.exports = __webpack_public_path__ + "static/img/happytree-desktop@2x.fb36298.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/happytree-desktop@2x.png
// module id = x1DF
// module chunks = 1